import { render } from "./InventoryView.vue?vue&type=template&id=519708c3"
import script from "./InventoryView.vue?vue&type=script&lang=js"
export * from "./InventoryView.vue?vue&type=script&lang=js"

import "./InventoryView.vue?vue&type=style&index=0&id=519708c3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__